// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"ccd13f48","707":"1c539bb6","730":"03010329"}[chunkId] + ".chunk.js";
};